import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import DataManagerConnectedTableComponent from 'webapp/components/data-manager/connected/table';
import NoResultsSourcesComponent from 'webapp/components/no-results/sources';

import type FlowIntegrationsSelectionPopup from 'webapp/services/flow/integrations-selection-popup';

export default class DatamanagerConnectedIndexRouteTemplate extends Component {
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('app-notifications') declare appNotificationsService: Service.AppNotifications;
	@service('flow/integrations-selection-popup')
	declare flowIntegrationsSelectionPopup: FlowIntegrationsSelectionPopup;
	@service('model-manager/sources') declare mmSourcesService: Service.ModelManager.Sources;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('account') declare accountService: Service.Account;

	get showSourcesConnectedPage(): boolean {
		return (
			this.mmSourcesService.hasConnectedSources ||
			!!this.appNotificationsService.connectRequests.length ||
			!!this.appNotificationsService.connectSelections.length
		);
	}

	@action
	newConnection(): void {
		if (this.accountService.handleDemo()) {
			return;
		}

		this.flowIntegrationsSelectionPopup.isEligibleToCheckToOpenPopup = false;
		this.navigationService.transitionToRoute('datamanager.available');
		this.analyticsService.event(TrackingEvent.NEW_CONNECTION, {
			origin: 'datasources',
		});
	}

	<template>
		{{#if this.showSourcesConnectedPage}}

			<DataManagerConnectedTableComponent @onAdd={{this.newConnection}} />

		{{else}}

			<NoResultsSourcesComponent @onCreate={{this.newConnection}} />

		{{/if}}
	</template>
}
